import { useState, useEffect } from 'react';
import moment from 'moment';

import { Input, DatePicker, InputProps, Button, FormInstance } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';

import './index.scss';

interface DatePickerLocalisedProps extends InputProps {
  date: string;
  setDate(date: string): void;
  disabledDate?(current: moment.Moment): boolean;
  formInstance?: FormInstance;
  formItemName?: string;
  showTime?: boolean;
};

const DatePickerLocalised = (props: DatePickerLocalisedProps) => {

  const {setDate, date, disabledDate, formInstance, formItemName, ...rest} = props;
  const [dateVal, setDateVal] = useState<any>(null);
  let format = 'MM/DD/YYYY';

  useEffect(() => {
    if (formInstance && formItemName) formInstance.setFieldsValue({ [formItemName]: date });
    if (props.showTime) format = 'MM/DD/YYYY HH:mm';
  }, [date]);

  const formatInputDate = (e: React.ChangeEvent<HTMLInputElement>) => {

    let val = e.target.value;
    let slashQuan = val.match(/\//g);

    // Cannot start with slash
    val = val.indexOf('/') === 0 && val.length === 1 ? '' : val;

    // remove multiple adjacent slashes
    while (val.indexOf('//') !== -1) {
      val = val.replace(/\/\//g,'/');
    }

    // if more than two slashes remove the 3rd and everything that comes after
    if (slashQuan && slashQuan.length > 2) {
      val = val.substr(0,val.lastIndexOf('/'));
    }

    if (val.length === 2) {

      val[1] === '/' ? val = '0' + val : val += '/';

    } else if (val.length === 5) {

      val[4] === '/' ? val = val.substr(0, 3) + '0' + val.substr(3, 2) : val += '/';

    } else if (props.showTime) {

      if (val.length === 11) {

        val = val.substr(0, 10) + ' ';

      } else if (val.length === 14) {

        val = val.substr(0, 13) + ':';

      }

      return props.setDate(val.substr(0, 16));
    }

    return props.setDate(val.trim().substr(0, 10));
  };

  const handleBackspace = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === 'Backspace') {
      let val = props.date;
      if (val.length === 3 || val.length === 6) {
        val = val.slice(0, val.length - 1);
        props.setDate(val);
      }
    }
  };

  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const date = e.target.value;
    if (moment(date).isValid()) {
      setDateVal(moment(date));
      props.setDate(moment(date).format(format));
    }
  };

  const onSelect = (val: moment.Moment) => {
    props.setDate(val.format(format))
    setDateVal(val);
  };

  const ClearButton = () => {
    return (
      <Button
        type="primary"
        onClick={() => {
          props.setDate('');
          setDateVal(null);
        }}
      >
        Clear
      </Button>
    );
  };

  return (
    <div className="custom-date-picker">
      <Input
        {...rest}
        value={props.date}
        onChange={formatInputDate}
        onKeyDown={handleBackspace}
        onBlur={onBlur}
        className='date-input'
        style={{
          width: 'calc(100% - 40px)',
          paddingTop: '6px',
        }}
      />
      <DatePicker
        onSelect={onSelect}
        className='date-picker-minimized'
        placeholder=''
        value={dateVal}
        inputReadOnly
        suffixIcon={<CalendarOutlined />}
        tabIndex={-1} // skip on tab-to-complete
        clearIcon={false}
        showTime={props.showTime ? {format: 'HH:mm'} : false}
        renderExtraFooter={() => <ClearButton />}
        style={{
          width: '40px',
          height: '34px',
          paddingBottom: '2px',
        }}
        disabled={props.disabled}
        disabledDate={props.disabledDate}
      />
    </div>
  );
};

export default DatePickerLocalised;